<script>
    export let orange = true;
</script>


<svg xmlns="http://www.w3.org/2000/svg" class="download-icon-img" class:orange={orange} viewBox="0 0 30 30">
    <path data-name="fticon-v1_download"
          d="M15 30.07 4.4 19.46l2.65-2.65 6.08 6.08V0h3.75v22.89l6.07-6.08 2.66 2.65ZM0 33.75v3.75h30v-3.75Z"
          fill="#fff"/>
</svg>


<style>
    .download-icon-img {
        border-bottom: 2px solid white;
        padding-bottom: 4px;
        width: 28px;
    }

    .orange {
        filter: invert(40%) sepia(70%) saturate(1696%) hue-rotate(336deg) brightness(103%) contrast(101%);
    }

    .download-icon-img:hover {
        filter: invert(40%) sepia(70%) saturate(1696%) hue-rotate(336deg) brightness(103%) contrast(101%);
    }

    .orange:hover {
        filter: none;
    }
</style>